import React, { Fragment } from 'react'
import { Field } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'
import { types } from 'app/constants/notificationType'

import './styles.scss'
import RadioButtonNotificationType from 'app/domains/common/TimePreferencesForm/RadioButtonNotificationType'

const bc = 'confirmation-notification-type-form'

const radioElements = [
  {
    text: 'Disable Text',
    value: types.EMAIL,
  },
  {
    text: 'Receive Text Only',
    value: types.SMS,
  },
  {
    text: 'Enable Text & Email',
    value: types.BOTH,
  },
]

class ConfirmationNotificationTypeForm extends React.Component {
  render() {
    const { description, handleSubmit } = this.props
    return (
      <Fragment>
        <span className={`${bc}__description`}>{description}</span>
        <form onSubmit={handleSubmit}>
          <div className={`${bc}__body`}>
            <Field
              classNameLabel={`${bc}__label`}
              classNameRadioElements={`${bc}__radio-elements`}
              name="notificationType"
              component={RadioButtonNotificationType}
              radioElements={radioElements}
            />
          </div>
        </form>
      </Fragment>
    )
  }
}

export default withTranslation('user')(ConfirmationNotificationTypeForm)
